import { CreateNS } from '../lib/createAPIBuilder';

export const installAPIDevice = (namespace: CreateNS) => {
    namespace('device')(({ prop, deps }) => {
        prop('id', deps.getDeviceId, {
            shouldNotManipulate: true,
        });
        prop('guid', deps.getGuid, null);
        prop('manufacturer', deps.getManufacturer, {
            shouldNotManipulate: true,
        });
        prop('platform', deps.getPlatform, {
            shouldNotManipulate: true,
        });
        const dm = deps.deviceMetadata;
        prop('type', () => dm.type, null);
        prop('brand', () => dm.brand, null);
        prop('model', () => dm.model, null);
        prop('firmwareVersion', () => dm.firmwareVersion, null);
        prop('osName', () => dm.osName, null);
        prop('osVersion', () => dm.osVersion, null);
    });
};
